import { jsx, jsxs } from "react/jsx-runtime";
import {
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Stack,
  Tooltip,
  useTheme
} from "@mui/material";
import { cloneElement } from "react";
function ActionBarItem(props) {
  const {
    id,
    icon,
    label,
    onClick,
    _internal,
    tooltip = "",
    disabled = false,
    color = "default",
    disableInteraction = false,
    testId = "tidal-actionbaritem",
    className = "",
    divider,
    mode,
    sx: propsSx,
    ...dataAttributes
  } = props;
  const theme = useTheme();
  if (!_internal) {
    console.warn("ActionBarItem must only be used as a child of ActionBar");
    return null;
  }
  const { size, menuMode, parentOnClick } = _internal;
  const btnColor = color === "default" ? void 0 : color;
  const handleClick = (event) => {
    if (disableInteraction) return;
    onClick?.(event);
    parentOnClick?.({ id, label });
  };
  const clonedIcon = cloneElement(icon, { fontSize: "inherit" });
  const sx = {
    ...disableInteraction ? { pointerEvents: "none" } : {},
    ...propsSx
  };
  const dividerSx = { height: "inherit" };
  if (mode === "menu") {
    const cssColor = color === "inherit" || color === "default" ? void 0 : (theme.vars ?? theme).palette[color].main;
    return /* @__PURE__ */ jsxs(
      MenuItem,
      {
        className,
        "data-testid": testId,
        disabled,
        divider,
        onClick: handleClick,
        sx,
        ...dataAttributes,
        children: [
          menuMode === "textIcon" && /* @__PURE__ */ jsx(ListItemIcon, { sx: { color: cssColor }, children: icon }),
          /* @__PURE__ */ jsx(ListItemText, { sx: { color: cssColor }, children: label })
        ]
      }
    );
  }
  if (menuMode === "iconOnly") {
    return /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: _internal.gap, children: [
      /* @__PURE__ */ jsx(Tooltip, { title: tooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
        IconButton,
        {
          className,
          color,
          "data-testid": testId,
          disabled,
          disableFocusRipple: disableInteraction,
          disableRipple: disableInteraction,
          onClick: handleClick,
          size,
          sx,
          ...dataAttributes,
          children: clonedIcon
        }
      ) }) }),
      divider && /* @__PURE__ */ jsx(Divider, { orientation: "vertical", sx: dividerSx })
    ] });
  }
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: _internal.gap, children: [
    /* @__PURE__ */ jsx(Tooltip, { title: tooltip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
      Button,
      {
        className,
        color: btnColor,
        "data-testid": testId,
        disabled,
        disableFocusRipple: disableInteraction,
        disableRipple: disableInteraction,
        fullWidth: true,
        onClick: handleClick,
        size,
        startIcon: menuMode !== "textOnly" && clonedIcon,
        sx,
        ...dataAttributes,
        children: label
      }
    ) }) }),
    divider && /* @__PURE__ */ jsx(Divider, { orientation: "vertical", sx: dividerSx })
  ] });
}
export {
  ActionBarItem
};
//# sourceMappingURL=ActionBarItem.js.map
